/**
 * @generated SignedSource<<4b1096c581abd0518bdd1e17c84c0eba>>
 * @relayHash 2cc5f541207c34a42f396eea110ff24c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21a4f2b2ef7dae284890e7e3c12d2f64e84333b5ce1b72f61e7b9e6fcdacba4f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainGroupByDropdownContentQuery$variables = {
  nodeId: string;
};
export type mainGroupByDropdownContentQuery$data = {
  readonly node: {
    readonly __typename: "JiraGroupedListView";
    readonly id: string;
    readonly viewSettings: {
      readonly groupByConfig: {
        readonly __id: string;
        readonly availableGroupByFieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldId: string;
              readonly id: string;
              readonly name: string;
            };
          } | null | undefined> | null | undefined;
        };
        readonly groupByField: {
          readonly name: string | null | undefined;
        } | null | undefined;
      };
    };
  } | {
    readonly __typename: "JiraListView";
    readonly id: string;
    readonly viewSettings: {
      readonly groupByConfig: {
        readonly __id: string;
        readonly availableGroupByFieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldId: string;
              readonly id: string;
              readonly name: string;
            };
          } | null | undefined> | null | undefined;
        };
        readonly groupByField: {
          readonly name: string | null | undefined;
        } | null | undefined;
      };
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type mainGroupByDropdownContentQuery = {
  response: mainGroupByDropdownContentQuery$data;
  variables: mainGroupByDropdownContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v7 = {
  "kind": "ScalarField",
  "name": "__id"
},
v8 = [
  {
    "kind": "RequiredField",
    "field": (v3/*: any*/),
    "action": "THROW",
    "path": "node.id"
  },
  {
    "kind": "RequiredField",
    "field": {
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "RequiredField",
                "field": {
                  "args": (v5/*: any*/),
                  "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                  "kind": "LinkedField",
                  "name": "availableGroupByFieldOptions",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": (v4/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v6/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                        }
                      ]
                    }
                  ],
                  "storageKey": "availableGroupByFieldOptions(first:10)"
                },
                "action": "THROW",
                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v7/*: any*/),
                    "action": "THROW",
                    "path": "node.viewSettings.groupByConfig.__id"
                  }
                ]
              }
            ]
          },
          "action": "THROW",
          "path": "node.viewSettings.groupByConfig"
        }
      ]
    },
    "action": "THROW",
    "path": "node.viewSettings"
  }
],
v9 = [
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraField",
            "kind": "LinkedField",
            "name": "groupByField",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ]
          },
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
            "kind": "LinkedField",
            "name": "availableGroupByFieldOptions",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "availableGroupByFieldOptions(first:10)"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainGroupByDropdownContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v8/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v8/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainGroupByDropdownContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "21a4f2b2ef7dae284890e7e3c12d2f64e84333b5ce1b72f61e7b9e6fcdacba4f",
    "metadata": {},
    "name": "mainGroupByDropdownContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "37908ab6d2b2cd0e1e165a0ccc03ffb5";

export default node;
